export const codes = {
  Thailand: '+66',
  Singapore: '+65',
};

export const countries = [
  {
    label: 'Singapore',
    value: 'Singapore',
  },
  {
    label: 'Thailand',
    value: 'Thailand',
  },
];

export const roles = [
  {
    label: 'Staff',
    value: 'admin',
  },
  {
    label: 'Customer',
    value: 'customer',
  },
];
